<template>
  <!-- 여행버튼 관리자 페이지 for 게시물 추가 -->
  <div>
    <div class="header-button-container" style="width: 100%">
      <button>Heelo</button>
    </div>
    <b-table striped hover :items="posts1" :fields="fields">
      <!-- <template v-slot:cell(id)="row">
        <b-form-input v-model="row.item.id" disabled />
      </template> -->
      <template v-slot:cell(save)="row">
        <b-button variant="success" @click="save(row.item)">저장</b-button>
      </template>
      <template v-slot:cell(contents)="row">
        <b-form-textarea v-model="row.item.title" />
      </template>
      <template v-slot:cell(title)="row">
        <b-form-textarea v-model="row.item.contents" />
      </template>
      <template v-slot:cell(link)="row">
        <b-form-textarea v-model="row.item.link" />
      </template>
      <template v-slot:cell(order)="row">
        <b-form-input v-model="row.item.order" />
      </template>
      <template v-slot:cell(category)="row">
        <b-form-select
          v-model="row.item.category"
          :options="categoryOptions"
        ></b-form-select>
      </template>
      <template v-slot:cell(location)="row">
        <!-- <b-form-input v-model="row.item.location" /> -->
        <b-form-select
          v-model="row.item.location"
          :options="locationOptions"
        ></b-form-select>
      </template>
      <template v-slot:cell(isHotPick)="row">
        <!-- <b-form-input v-model="row.item.isHotPick" /> -->
        <b-form-select
          v-model="row.item.isHotPick"
          :options="hotPickOptinos"
        ></b-form-select>
      </template>
      <template v-slot:cell(thumbnail)="row">
        <b-img
          :src="row.item.thumbnail"
          @click="selectFile(row.item)"
          width="200"
          height="245"
        />
      </template>
    </b-table>

    <form ref="form">
      <input
        id="files"
        type="file"
        name="file"
        ref="uploadInput"
        accept="image/*"
        :multiple="false"
        @change="detectFiles($event)"
        style="display: hidden"
      />
    </form>
  </div>
</template>

<script>
import firebase from "firebase";

export default {
  data() {
    return {
      categoryOptions: [
        {
          value: null,
          text: "카테고리를 아래에서 선택해주세요!",
          disabled: true,
        },
        {
          value: "1",
          text: "국내 여행지",
        },
        {
          value: "2",
          text: "매거진",
        },
      ],
      locationOptions: [
        {
          value: null,
          text: "카테고리를 아래에서 선택해주세요!",
          disabled: true,
        },
        {
          value: "충청북도",
          text: "충청북도",
        },
        {
          value: "충청남도",
          text: "충청남도",
        },
        {
          value: "전라북도",
          text: "전라북도",
        },
        {
          value: "전라남도",
          text: "전라남도",
        },
        {
          value: "강원도",
          text: "강원도",
        },
        {
          value: "울산광역시",
          text: "울산광역시",
        },
        {
          value: "대구광역시",
          text: "대구광역시",
        },
        {
          value: "경상북도",
          text: "경상북도",
        },
        {
          value: "경상남도",
          text: "경상남도",
        },
        {
          value: "부산광역시",
          text: "부산광역시",
        },
        {
          value: "인천광역시",
          text: "인천광역시",
        },
        {
          value: "서울특별시",
          text: "서울특별시",
        },
        {
          value: "제주도",
          text: "제주도",
        },
      ],
      hotPickOptinos: [
        {
          value: null,
          text: "카테고리를 아래에서 선택해주세요!",
          disabled: true,
        },
        {
          value: true,
          text: "Yes",
        },
        {
          value: false,
          text: "No",
        },
      ],
      fields: [
        // { key: "id", label: "id" },
        { key: "save", label: "저장" }, // not in document object, just for save button
        { key: "title", label: "제목" },
        { key: "contents", label: "부제목" },
        { key: "link", label: "퍼버 링크" },
        { key: "order", label: "순서" },
        { key: "category", label: "카테고리" },
        { key: "thumbnail", label: "썸네일" },
        { key: "location", label: "지역" },
        { key: "isHotPick", label: "HP" },
      ],
      posts1: [],
      items: [],
      selectedItem: {}, // when you clicked img file
    };
  },
  mounted() {
    firebase
      .firestore()
      .collection("posts1")
      .get()
      .then((snap) => {
        const testCollection = [];
        snap.forEach((doc, index) => {
          testCollection.push({ ...doc.data(), id: doc.id });
        });

        testCollection.sort((a, b) => {
          return a.order - b.order;
        });

        this.posts1 = testCollection.map((item) => {
          return {
            ...item,
            isHotPick: item.isHotPick === true ? true : false,
          };
        });
      });
  },
  methods: {
    selectFile: function (selectedItem) {
      this.$refs.uploadInput.click();
      this.selectedItem = selectedItem;
      console.log(this.selectedItem);
    },
    detectFiles(e) {
      let fileList = e.target.files || e.dataTransfer.files;
      Array.from(Array(fileList.length).keys()).map((x) => {
        this._upload(fileList[0]);
      });
    },
    _upload(file) {
      const storageRef = firebase
        .storage()
        .ref("images")
        .child(file.name)
        .put(file);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          console.log((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            this.save({ ...this.selectedItem, thumbnail: url });
          });
        }
      );
    },
    show() {
      console.log(posts1[0]);
    },
    save(item) {
      var result = {
        ...item,
        category: String(item.category),
      };
      console.log(typeof item.isHotPick);
      console.log(Boolean(item.isHotPick));
      console.log(item);
      firebase
        .firestore()
        .collection("posts1")
        .doc(item.id)
        .update(result)
        .then(() => {
          console.log({ ...item, isHotPick: Boolean(item.isHotPick) });
          alert("수정을 성공적으로 완료 했습니다.");
        })
        .catch(() => {
          alert("수정에 실패 했습니다. 관리자에게 문의 하세요.");
        });
    },
  },
};
</script>

<style></style>
